import React, { useContext } from 'react';

import { AppDataContext } from '../../context';
import SpinLoader from '../SpinLoader';
import type { AllowedCourseItem } from '../../types';
import {
  LeadingChangeDynamicSvg,
  LeadingForwardDynamicSvg,
  LeadingOthersDynamicSvg,
  LeadingSelfDynamicSvg,
  WhyLeadDynamicSvg,
} from './svgProgressLoader';

type CourseCompletion = {
  percent: number;
  earned: number;
  possible: number | null;
} | undefined;

interface CourseProgressProps {
  getCourseCompletions: (id: string) => CourseCompletion;
  isUserCoursesCompletionsLoaded: boolean;
}

const CourseProgress: React.FC<CourseProgressProps> = ({ getCourseCompletions, isUserCoursesCompletionsLoaded }) => {
  const { allowedCourses } = useContext(AppDataContext);

  const courseProgressMap: AllowedCourseItem[] = allowedCourses.filter((course) => course.display_certificate_badge);

  const courseIconMap = {
    why_lead: WhyLeadDynamicSvg,
    leading_self: LeadingSelfDynamicSvg,
    leading_others: LeadingOthersDynamicSvg,
    leading_change: LeadingChangeDynamicSvg,
    leading_forward: LeadingForwardDynamicSvg,
  };

  const getCourseProgressPercent = (id: string): number => {
    const completions: CourseCompletion = getCourseCompletions(id);

    if (!completions?.percent) {
      return 0;
    }

    return completions.percent * 100;
  };

  if (!isUserCoursesCompletionsLoaded) {
    return (
      <div className="course-progress-svg-container">
        <SpinLoader size={45} containerHeight="145px" />
      </div>
    );
  }

  return (
    <div className="course-progress-svg-container">
      {courseProgressMap.map(({
        course_id: id,
        progress_badge_icon: icon = '',
        progress_badge_title: title = '',
      }: AllowedCourseItem) => (
        <div
          key={id}
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: 93,
          }}
        >
          {courseIconMap[icon]({ overlayWidth: getCourseProgressPercent(id) })}
          <span
            style={{
              textAlign: 'center',
              marginTop: '5px',
              color: 'white',
            }}
          >
            {title}
          </span>
        </div>
      ))}
    </div>
  );
};

export default CourseProgress;
